{
    "executive": {
        "title": "Executive dashboard",
        "subtitle": "The four pillars on one page, from figures computed on a schedule.",
        "computed_at": "Figures as at {{time}}",
        "scoped": "These figures cover the branches you have access to, not the whole Bank."
    },
    "filters": {
        "from": "From",
        "to": "To",
        "apply": "Apply"
    },
    "cards": {
        "trend": "Trend",
        "no_comparison": "No comparable period",
        "points": "{{points}} points",
        "base_one": "1 record",
        "base_other": "{{count}} records",
        "complaints_received": "Complaints received",
        "complaints_sla_breached": "SLA breaches",
        "queue_tickets": "Branch visits",
        "queue_wait_seconds": "Mean waiting time",
        "cc_contacts": "Contacts handled",
        "cc_abandoned": "Abandoned contacts",
        "cc_first_contact_resolution": "First contact resolution",
        "survey_responses": "Survey responses",
        "survey_nps": "Net Promoter Score"
    },
    "map": {
        "title": "Across Oman",
        "by_branch": "By branch",
        "branch": "Branch",
        "no_data": "No data",
        "base_one": "1 record",
        "base_other": "{{count}} records"
    },
    "reports": {
        "title": "Reports",
        "subtitle": "Saved questions, and the answers on demand.",
        "new": "New report",
        "built_in": "Built in",
        "run": "Run",
        "last_run": "Last run {{date}}"
    },
    "builder": {
        "new": "New report",
        "subtitle": "Pick what to count, what to group it by, and what to leave out.",
        "what": "What to measure",
        "dataset": "Data",
        "measures": "Measures",
        "group_by": "Group by",
        "no_dimensions": "No grouping — a single row with the totals.",
        "filters": "Filters",
        "value": "Value",
        "details": "Report details",
        "key": "Key",
        "name_en": "Name (English)",
        "name_ar": "Name (Arabic)",
        "visualisation": "Chart type",
        "row_limit": "Row limit",
        "visibility": "Visibility",
        "sharing_note": "Sharing a report shares the question, not the answer — everybody who opens it sees only the data they are allowed to see.",
        "preview": "Preview",
        "preview_note": "{{count}} rows in {{ms}} ms",
        "pick_a_measure": "Choose at least one measure to see a preview.",
        "system_readonly": "This is a built-in report. Export it, or copy it and change the copy."
    },
    "visibility": {
        "private": "Only me",
        "public": "Everybody",
        "roles": "Chosen roles"
    },
    "visualisations": {
        "table": "Table",
        "bar": "Bar chart",
        "line": "Line chart",
        "pie": "Pie chart",
        "heatmap": "Heat map",
        "kpi": "Single figure"
    },
    "grains": {
        "day": "Day",
        "week": "Week",
        "month": "Month",
        "quarter": "Quarter",
        "year": "Year"
    },
    "operators": {
        "equals": "is",
        "not_equals": "is not",
        "in": "is one of",
        "not_in": "is not one of",
        "greater_than": "is more than",
        "greater_or_equal": "is at least",
        "less_than": "is less than",
        "less_or_equal": "is at most",
        "between": "is between",
        "contains": "contains",
        "starts_with": "starts with",
        "is_null": "is empty",
        "not_null": "is not empty"
    },
    "datasets": {
        "complaints": "Complaints",
        "interactions": "Customer timeline",
        "queue_tickets": "Branch visits",
        "survey_responses": "Survey responses",
        "conversations": "Contact centre"
    },
    "table": {
        "empty": "No rows matched.",
        "total": "Total",
        "of_base_one": "of 1",
        "of_base_other": "of {{count}}",
        "truncated": "Showing the first {{count}} rows. Add filters, or export to CSV for everything."
    },
    "schedules": {
        "title": "Scheduled reports",
        "subtitle": "Reports that produce and send themselves.",
        "new": "New schedule",
        "empty": "Nothing is scheduled yet.",
        "report": "Report",
        "when": "When",
        "frequency": "How often",
        "time": "Time",
        "day": "Day",
        "day_of_month": "Day of the month",
        "day_of_month_help": "A schedule set for the 31st still runs in February, on the last day.",
        "format": "Format",
        "recipients": "Send to",
        "next": "Next run",
        "paused": "Paused",
        "narrative": "Written summary",
        "narrative_help": "An Arabic report carries a summary composed in Arabic, not an English one translated.",
        "skip_empty": "Do not send when there is nothing to report",
        "skip_empty_help": "A report that arrives empty every week is one people learn to delete unread."
    },
    "frequencies": {
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly"
    },
    "runs": {
        "title": "Report history",
        "subtitle": "Everything that was produced, and everything that failed.",
        "empty": "Nothing has been produced yet.",
        "report": "Report",
        "status": "Status",
        "trigger": "Started by",
        "rows": "Rows",
        "duration": "Took",
        "when": "When",
        "expired": "File expired",
        "scope": "Scope: {{scope}}",
        "statuses": {
            "running": "Running",
            "completed": "Completed",
            "failed": "Failed"
        },
        "triggers": {
            "manual": "A person",
            "scheduled": "The schedule"
        }
    }
}
